import { useEffect } from "react";

/**
 * Hook que conecta una función de guardado con un `ref` externo.
 * @param onSaveRef - ref recibido desde el padre
 * @param saveFn - función async de guardado que querés exponer
 */
export function useStepSave(onSaveRef, saveFn) {
  useEffect(() => {
    if (onSaveRef) {
      onSaveRef.current = saveFn;
    }
  }, [onSaveRef, saveFn]);
}
